module.exports = __webpack_public_path__ + "img/chromatography_active.75c740b6.svg";